import { useState, FormEvent } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { authService } from '../../services/auth.service';
import { Input } from '../common/Input';
import { Button } from '../common/Button';
import { ROUTES } from '../../utils/constants';

export function SetNewPasswordForm() {
  const { t } = useTranslation('auth');
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token') ?? '';

  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setError('');

    if (password !== confirmPassword) {
      setError(t('register.passwordsNoMatch'));
      return;
    }
    if (password.length < 8) {
      setError(t('register.passwordTooShort'));
      return;
    }

    setIsLoading(true);
    try {
      await authService.resetPassword(token, password);
      navigate(ROUTES.LOGIN, { state: { passwordResetSuccess: true } });
    } catch (err) {
      setError(err instanceof Error ? err.message : t('setNewPassword.resetFailed'));
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      {error && (
        <div className="p-3 bg-red-50 border border-red-200 rounded text-red-700 text-sm">
          {error}
        </div>
      )}

      <Input
        type="password"
        label={t('setNewPassword.password')}
        placeholder={t('setNewPassword.passwordPlaceholder')}
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        required
        autoComplete="new-password"
        helperText={t('register.passwordHelp')}
      />

      <Input
        type="password"
        label={t('setNewPassword.confirmPassword')}
        placeholder={t('setNewPassword.confirmPasswordPlaceholder')}
        value={confirmPassword}
        onChange={(e) => setConfirmPassword(e.target.value)}
        required
        autoComplete="new-password"
      />

      <Button type="submit" className="w-full" loading={isLoading}>
        {t('setNewPassword.submitButton')}
      </Button>
    </form>
  );
}
